import BigNumber from 'bignumber.js'
import { ethers } from 'ethers'
import { getDecimalAmount } from 'utils/formatBalance'

export const deployNewCollection = async (contract, data, version) => {
  return version === 'v1'
    ? contract.deployNewERC721Token(
        data.projectName,
        data.nftSymbol,
        data.initBaseUrl,
        data.noRevealUrl,
        data.maxSupply,
        ethers.utils.parseEther(data.pricePerMint),
        data.maxMintPerTx,
        data.maxMintPerAddress,
      )
    : contract.deployNewERC721Token(
        data.projectName,
        data.nftSymbol,
        data.initBaseUrl,
        data.noRevealUrl,
        data.maxSupply,
        ethers.utils.parseEther(data.pricePerMint),
        data.maxMintPerTx,
        data.maxMintPerAddress,
        {
          value: ethers.utils.parseEther(`${data.ftmFee}`),
        },
      )
}

export const setBaseUri = async (contract, baseUri) => {
  return contract.setBaseURI(baseUri)
}

export const setNotRevealedUri = async (contract, notRevealedUri) => {
  return contract.setNotRevealedURI(notRevealedUri)
}

export const setPrice = async (contract, price) => {
  return contract.setPrice(ethers.utils.parseEther(price))
}

export const setPriceToken = async (contract, price, decimals) => {
  return contract.setpricetoken(getDecimalAmount(price, decimals).toString())
}

export const setToken = async (contract, token) => {
  return contract.setToken(token)
}

export const setMaxMintPerTx = async (contract, maxMintPerTx) => {
  return contract.setMaxMintPerTx(maxMintPerTx)
}

export const setMaxMintPerAddress = async (contract, maxMintPerAddress) => {
  return contract.setMaxMintPerAddress(maxMintPerAddress)
}

export const transferOwnership = async (contract, newOwner) => {
  return contract.transferOwnership(newOwner)
}

export const withdraw = async (contract, address, amount, version, decimals) => {
  return version === 'v1'
    ? contract.WithdrawAll()
    : contract.WithdrawERC20(address, new BigNumber(amount).times(new BigNumber(10).pow(decimals || 18)).toString())
}

export const showNFTs = async (contract) => {
  return contract.showNFTs()
}

export const pause = async (contract, state) => {
  return contract.pause(state)
}

export const pausedWithERC20 = async (contract, state) => {
  return contract.pausedWithERC20(state)
}

export const setOnlyWhitelisted = async (contract, state) => {
  return contract.setOnlyWhitelisted(state)
}

export const whitelistUsers = async (contract, addresses) => {
  return contract.whitelistUsers(addresses)
}

export const mintGiveaway = async (contract, amount, address, version) => {
  return version === 'v1' ? contract.mintGiveaway(amount) : contract.mintGiveaway(address, amount)
}

export const buyNFT = async (contract, amount, value, version) => {
  return version === 'v1'
    ? contract.buyNFT(`${amount}`, {
        value: ethers.utils.parseEther(`${value}`),
      })
    : contract.buyNFT_WithERC20(amount)
}

export const addWhitelist = async (contract, address) => {
  return contract.add(address)
}

export const setPayWithDMD = async (contract, state) => {
  return contract.setPayWithDMD(state)
}

export const setPayFTM = async (contract, state) => {
  return contract.setPayFTM(state)
}

export const updatefeeFTM = async (contract, amount) => {
  return contract.updatefeeFTM(ethers.utils.parseEther(`${amount}`))
}

export const updatefeeDMD = async (contract, amount) => {
  return contract.setAmount(ethers.utils.parseEther(`${amount}`))
}
